<template>
  <div class="card">
    <div class="card-image">
      <figure class="image is-4by3">
        <img :src="listing.imageURL" :alt="listing.title + ' image'" class="listing-image">
      </figure>
    </div>

    <div class="card-content">
      <div class="content">
          <h3>{{ this.limitedTitle }}</h3>
          
          {{ this.limitedDescription }}

          <br><br>
          <time>{{ listing.publishedDate }}</time>

          <div class="columns is-vcentered buttons-column">
            <div class="column">
              <b-button @click="onView" type="is-primary">View</b-button>
            </div>
            <div class="column price-column">
              <p class="is-size-4 has-text-primary">{{ this.listing.price }} €</p>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ListingMiniature",
  props: {
    // The listing prop must be an object
    // in the following format:
    // 
    // {
    //   id: Number,
    //   title: String,
    //   description: String,
    //   price: Number,
    //   imageURL: String,
    //   publishedDate: String
    // }
    listing: {
      type: Object,
      required: true
    },
    queryIndex: {
      type: Number,
      required: true
    },
    listingIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    limitedDescription() {
      let limit = 64
      let description = this.listing.description

      if (description.length > limit) {
        return description.substring(0, limit) + '...'
      }

      return description
    },
    limitedTitle() {
      let limit = 32
      let title = this.listing.title

      if (title.length > limit) {
        return title.substring(0, limit) + '...'
      }

      return title
    }
  },
  methods: {
    onView () {
      this.$emit('clicked', this.queryIndex, this.listingIndex)
    }
  }
};

</script>

<style lang="scss" scoped>

.buttons-column {
    margin-top: 0.6666em;
}

.listing-image {
  object-fit: cover;
}

.card {
  min-height: 256px;
}

.price-column {
  text-align: right;
}

</style>